<template>
  <transition name="fade">
    <div
      v-show="enabledPain"
      class="peers-info-pain"
    >
      <div class="pain-header">
        <span class="pain-close" @click="$emit('onClickClose')">
          <img :src="require('@/assets/images/icons/cross.png')"/>
        </span>
        <span>{{ $t('common.menus.member') }}</span>
      </div>
      <div class="pain-body">
        <template v-if="!cafeRoom">
          <div class="attribute">{{ videoRoom.meetingTitle }}</div>
          <div class="attribute">{{ videoRoom.startAt | moment('HH:mm') }}〜{{ videoRoom.endAt | moment('HH:mm') }}</div>
        </template>
        <div class="peers-wrapper">
          <div class="peers">
            <peer-info-cell
              :avatar="guest ? null : signedInUser.meta.avatar"
              :guest="guest"
              :displayName="myPeer.displayName"
              :disabledMic="!myPeer.micState"
              :disabledWebcam="!myPeer.webcamState"
              :isRaisedHands="myPeer.raisedHandsState"
            />
            <peer-info-cell
              v-for="(peer, peerId) in peers"
              :key="peerId"
              :avatar="avatarByUserId(peerId)"
              :guest="guestByUserId(peerId)"
              :displayName="peer.displayName"
              :disabledMic="!peer.micState"
              :disabledWebcam="!peer.webcamState"
              :isRaisedHands="peer.raisedHandsState"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import User from '@/store/models/User'
import PeerInfoCell from '@/components/molecules/room/PeerInfoCell'

export default {
  name: 'PeersInfoPain',
  components: {
    PeerInfoCell
  },
  props: {
    enabledPain: Boolean,
    videoRoom: Object,
    cafeRoom: {
      type: Boolean,
      default: false
    },
    guest: Boolean
  },
  computed: {
    avatarByUserId: function() {
      return function(id) {
        return this.guest ?
               this.videoRoom.users.filter((user) => user.id == id)[0]?.meta?.avatar :
               User.find(id)?.meta?.avatar
      }
    },
    guestByUserId: function() {
      return function(id) {
        return this.videoRoom.temporaryGuestUserIds.includes(Number(id))
      }
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser',
      myPeer: 'roomPeers/myPeer',
      peers: 'roomPeers/peers'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.peers-info-pain {
  position: absolute;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;

  @include mq(md) {
    position: relative;
    width: 350px !important;
  }
}

.pain-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  background-color: white;
  border-bottom: 1px solid $dark-border-color;
  font-weight: 600;
  color: $secondary-color;

  &:after {
    display: block;
    content: "";
    width: 26px;
  }

  .pain-close {
    display: inline-block;
    height: 26px;
    width: 26px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      padding: 3px;
    }
  }
}

.pain-body {
  flex-grow: 1;
  background-color: #FAFAFA;
  display: flex;
  flex-direction: column;

  .attribute {
    padding: 20px 25px;
    font-weight: 600;
    color: $secondary-color;
    border-bottom: 1px solid $light-border-color;
  }

  .peers-wrapper {
    flex-grow: 1;
    position: relative;

    .peers {
      position: absolute;
      width: 100%;
      height: 100%;
      padding: 20px 25px;
      overflow-y: auto;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transform: translate(0px, 0px);
  transition: transform .3s;
}
.fade-enter, .fade-leave-to {
  transform: translateX(100vw) translateX(0px);

  @include mq(md) {
    transform: translateX(350px) translateX(0px);
  }
}
</style>
